import { render, staticRenderFns } from "./TicketDetailsCustom.vue?vue&type=template&id=0bcb023b&scoped=true&"
import script from "./TicketDetailsCustom.vue?vue&type=script&lang=js&"
export * from "./TicketDetailsCustom.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetailsCustom.vue?vue&type=style&index=0&id=0bcb023b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb023b",
  null
  
)

export default component.exports